import { AxiosPromise } from 'axios';

import { request } from '../../baserequest';
import { CategoryType } from './types';
import { paginatedresult } from '../../../types/pagination';


const APIURL = process.env.REACT_APP_SKALO_API;

const CategoryList = ():AxiosPromise<paginatedresult<CategoryType>> => {
  return request({
    options:{
      url: `${APIURL}categorylist/?limit=40`,
      method: 'GET',
    },
  }).then((response) => ({
    ...response,
    data: {
      ...response.data,
      results: response.data.results,
    },
  }));
};

export const categoryQuery = { CategoryList };
